
    
        var maquetteH = require('maquette').h;
        var h = function(selector, props, children) {
          var attributes = Object.assign({}, props.attributes || {}, props);
          delete attributes["attributes"];

          // This should be done by pug-vdom, oh well...
          if (attributes.class) {
            selector += "." + attributes.class.trim().split(/ +/).join(".");
            delete attributes["class"];
          }

          return maquetteH(selector, attributes, children);
        }
      ;
    function render(context, h, text = (string) => string) {
  if (!pugVDOMRuntime) throw "pug-vdom runtime not found.";
  var runtime = pugVDOMRuntime
  var locals = context;
  var self = locals;
  var remainingKeys = pugVDOMRuntime.enterLocalsScope(locals);
  for (var prop in remainingKeys) {
    eval('var ' + prop + ' =  locals.' + prop);
  }
  var n0Child = []
  var n530Child = []
  var n531Child = []
  var n532Child = []
  n532Child = n532Child.concat(text(t('.instance_id')))
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n532 = h('label', props, n532Child)
  n531Child.push(n532)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n531 = h('div', props, n531Child)
  n530Child.push(n531)
  var n533Child = []
  var n534Child = []
  var n535Child = []
  var n536Child = []
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'input'},{name:'name', val: "instanceId"},{name:'value', val: shadow.instanceId},{name:'type', val: "text"}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n536 = h('input', props, n536Child)
  n535Child.push(n536)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n535 = h('div', props, n535Child)
  n534Child.push(n535)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n534 = h('div', props, n534Child)
  n533Child.push(n534)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n533 = h('div', props, n533Child)
  n530Child.push(n533)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n530 = h('div', props, n530Child)
  n0Child.push(n530)
  var n537Child = []
  var n538Child = []
  var n539Child = []
  n539Child = n539Child.concat(text(t('.title')))
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n539 = h('label', props, n539Child)
  n538Child.push(n539)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n538 = h('div', props, n538Child)
  n537Child.push(n538)
  var n540Child = []
  var n541Child = []
  var n542Child = []
  var n543Child = []
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'input'},{name:'name', val: "title"},{name:'value', val: shadow.title},{name:'type', val: "text"}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n543 = h('input', props, n543Child)
  n542Child.push(n543)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n542 = h('div', props, n542Child)
  n541Child.push(n542)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n541 = h('div', props, n541Child)
  n540Child.push(n541)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n540 = h('div', props, n540Child)
  n537Child.push(n540)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n537 = h('div', props, n537Child)
  n0Child.push(n537)
  var n544Child = []
  var n545Child = []
  var n546Child = []
  n546Child = n546Child.concat(text(t('.text')))
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n546 = h('label', props, n546Child)
  n545Child.push(n546)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n545 = h('div', props, n545Child)
  n544Child.push(n545)
  var n547Child = []
  var n548Child = []
  var n549Child = []
  var n550Child = []
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'input'},{name:'name', val: "text"},{name:'value', val: shadow.text},{name:'type', val: "text"}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n550 = h('input', props, n550Child)
  n549Child.push(n550)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n549 = h('div', props, n549Child)
  n548Child.push(n549)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n548 = h('div', props, n548Child)
  n547Child.push(n548)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n547 = h('div', props, n547Child)
  n544Child.push(n547)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n544 = h('div', props, n544Child)
  n0Child.push(n544)
  var n551Child = []
  var n552Child = []
  var n553Child = []
  n553Child = n553Child.concat(text(t('.delay_base')))
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n553 = h('label', props, n553Child)
  n552Child.push(n553)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n552 = h('div', props, n552Child)
  n551Child.push(n552)
  var n554Child = []
  var n555Child = []
  var n556Child = []
  var n557Child = []
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'input'},{name:'name', val: "delay[epoch]"},{name:'value', val: shadow.delay.epoch},{name:'type', val: "number"}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n557 = h('input', props, n557Child)
  n556Child.push(n557)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n556 = h('div', props, n556Child)
  n555Child.push(n556)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n555 = h('div', props, n555Child)
  n554Child.push(n555)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n554 = h('div', props, n554Child)
  n551Child.push(n554)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n551 = h('div', props, n551Child)
  n0Child.push(n551)
  var n558Child = []
  var n559Child = []
  var n560Child = []
  n560Child = n560Child.concat(text(t('.delay_seconds')))
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n560 = h('label', props, n560Child)
  n559Child.push(n560)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n559 = h('div', props, n559Child)
  n558Child.push(n559)
  var n561Child = []
  var n562Child = []
  var n563Child = []
  var n564Child = []
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'input'},{name:'name', val: "delay[seconds]"},{name:'value', val: shadow.delay.seconds},{name:'type', val: "number"},{name:'step', val: "0.01"}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n564 = h('input', props, n564Child)
  n563Child.push(n564)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n563 = h('div', props, n563Child)
  n562Child.push(n563)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n562 = h('div', props, n562Child)
  n561Child.push(n562)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n561 = h('div', props, n561Child)
  n558Child.push(n561)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n558 = h('div', props, n558Child)
  n0Child.push(n558)
  pugVDOMRuntime.exitLocalsScope()
  return n0Child
}
;
    module.exports = function(locals) {
      locals = Object.assign(window.DEFAULT_TEMPLATE_LOCALS || {}, locals || {});
      return render.call(this, locals, h);
    };
  